var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, enableProdMode, ViewChild, NgZone } from '@angular/core';
import { Platform, LoadingController, NavController } from 'ionic-angular';
import { LocalStorageProvider } from '../providers/local-storage';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { AuthProvider } from '../providers/auth';
import { UserProvider } from '../providers/user';
import { API } from '../providers/api';
import { AppNavProvider } from '../providers/app_nav';
import { OnPremiseProvider } from '../providers/on-premise';
import { LicenseStatus } from '../pages/license-error-page/license-error-page';
import { InspectorBusyProvider } from '../providers/inspector-busy';
import { ModalProvider } from '../providers/popup/modal';
import { PopoverProvider } from '../providers/popup/popover';
import { TrackableJobProvider } from '../providers/trackable-job';
import { TranslationProvider } from '../providers/translation';
import { TranslateService } from '@ngx-translate/core';
import { SettingsProvider } from '../providers/settings';
enableProdMode();
var BrainBuilder = /** @class */ (function () {
    function BrainBuilder(auth, userProvider, translationProvider, ngZone, appNavProvider, onPremiseProvider, api, platform, statusBar, splashScreen, loadingCtrl, popoverProvider, modalProvider, localStorageProvider, inspectorBusyProvider, trackableJobProvider, translate, settingsProvider) {
        var _this = this;
        this.auth = auth;
        this.userProvider = userProvider;
        this.translationProvider = translationProvider;
        this.ngZone = ngZone;
        this.appNavProvider = appNavProvider;
        this.onPremiseProvider = onPremiseProvider;
        this.api = api;
        this.platform = platform;
        this.statusBar = statusBar;
        this.splashScreen = splashScreen;
        this.loadingCtrl = loadingCtrl;
        this.popoverProvider = popoverProvider;
        this.modalProvider = modalProvider;
        this.localStorageProvider = localStorageProvider;
        this.inspectorBusyProvider = inspectorBusyProvider;
        this.trackableJobProvider = trackableJobProvider;
        this.translate = translate;
        this.settingsProvider = settingsProvider;
        this.showLoadingScreen = true;
        this.externalServiceError = false;
        this.licenseExpiringSoonDisplayed = false;
        this.login = true;
        this.migrate = false;
        this.dashboard = false;
        this.showOnPremiseHeader = false;
        platform
            .ready()
            .then(function () { return __awaiter(_this, void 0, void 0, function () {
            var health, inspectorStatus;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        statusBar.styleDefault();
                        splashScreen.hide();
                        return [4 /*yield*/, this.onPremiseProvider.healthcheck()];
                    case 1:
                        health = _a.sent();
                        return [4 /*yield*/, this.onPremiseProvider.getInspectorStatus()];
                    case 2:
                        inspectorStatus = _a.sent();
                        this.handleInspectorStatus(inspectorStatus);
                        this.showOnPremiseHeader = this.onPremiseProvider.isOnPremiseElectronApp();
                        if (!this.handleOnPremiseHealthcheck(health)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.verifyAuth()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.showLoadingScreen = false;
                        return [2 /*return*/];
                }
            });
        }); })
            .then(function () {
            _this.initializeAfterLoadingScreen();
        }, function () {
            _this.initializeAfterLoadingScreen();
        });
    }
    BrainBuilder.prototype.initializeAfterLoadingScreen = function () {
        this.initializeBackgroundProcessing();
        this.initializeTranslation();
    };
    /**
     * Set up processing that needs to run in the background of the application
     */
    BrainBuilder.prototype.initializeBackgroundProcessing = function () {
        var _this = this;
        this.onPremiseProvider.subscribeForHealthCheck(function (data) {
            return _this.ngZone.run(function () {
                _this.handleOnPremiseHealthcheck(data);
            });
        });
        this.onPremiseProvider.subscribeForInspectorStatus(function (data) {
            return _this.ngZone.run(function () {
                _this.handleInspectorStatus(data);
            });
        });
        this.trackableJobProvider.initializeJobPolling();
    };
    BrainBuilder.prototype.initializeTranslation = function () {
        var _this = this;
        this.userProvider.userLoaded.subscribe(function (user) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.settingsProvider.load()];
                    case 1:
                        _a.sent();
                        this.translationProvider.setLanguageFromSystem();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    BrainBuilder.prototype.handleOnPremiseHealthcheck = function (_a) {
        var brainBank = _a.brainBank, sdkService = _a.sdkService, detectionService = _a.detectionService, cudaUpToDate = _a.cudaUpToDate, license = _a.license;
        // if we don't have a license it means that license check was disabled
        // and we do not need to check inside
        if (sdkService && license) {
            if (license.licenseStatus === 'expired') {
                this.goToPage("LicenseErrorPage", __assign({}, license, { licenseStatus: LicenseStatus.Expired }));
                return false;
            }
            if (license.licenseStatus === 'missing') {
                this.goToPage("LicenseErrorPage", __assign({}, license, { licenseStatus: LicenseStatus.Missing }));
                return false;
            }
            if (this.isLicenseExpiringSoon(license.licenseExpirationDate) && !this.licenseExpiringSoonDisplayed) {
                this.licenseExpiringSoonDisplayed = true;
                this.goToPage("LicenseErrorPage", __assign({}, license, { licenseStatus: LicenseStatus.ExpiringSoon }));
                return false;
            }
        }
        var qualifiedDetectionServiceHealth = this.getQualifiedDetectionServiceHealth(detectionService);
        // cudaUpToDate needs to explicitly be false to trigger an error
        if (!brainBank || !sdkService || !qualifiedDetectionServiceHealth || cudaUpToDate === false) {
            this.externalServiceError = true;
            this.goToPage("ExternalServiceAlertPage", {
                brainBank: brainBank,
                sdkService: sdkService,
                detectionService: qualifiedDetectionServiceHealth,
                cudaUpToDate: cudaUpToDate
            });
            return false;
        }
        else if (this.isOnAlertPage() || this.isOnLicenseErrorPage()) {
            this.goToPage("DashboardPage");
        }
        return true;
    };
    /**
     * Return false to indicate the detection service is unhealthy only if
     * applicable to the current user capabilities
     */
    BrainBuilder.prototype.getQualifiedDetectionServiceHealth = function (detectionService) {
        var notifyDetection = this.isLoggedIn && this.userProvider.hasDetectionBrainsCapability();
        return notifyDetection ? detectionService : true;
    };
    BrainBuilder.prototype.goToPage = function (name, data) {
        this.popoverProvider.closeAll();
        this.modalProvider.closeAll();
        this.nav.setRoot(name, data);
    };
    BrainBuilder.prototype.handleInspectorStatus = function (_a) {
        var isBusy = _a.isBusy;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!isBusy) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.inspectorBusyProvider.showBusyModal()];
                    case 1:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.inspectorBusyProvider.dismissBusyModal()];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BrainBuilder.prototype.isLicenseExpiringSoon = function (licenseExpirationDate) {
        var expirationDate = new Date(licenseExpirationDate).getTime();
        var currentDate = new Date().getTime();
        var month = 1000 * 60 * 60 * 24 * 30;
        return expirationDate - currentDate < month;
    };
    BrainBuilder.prototype.isOnAlertPage = function () {
        var active = this.nav.getActive();
        return active && active.id === 'ExternalServiceAlertPage';
    };
    BrainBuilder.prototype.isOnLicenseErrorPage = function () {
        var active = this.nav.getActive();
        return active && active.id === 'LicenseErrorPage';
    };
    BrainBuilder.prototype.verifyAuth = function () {
        var token = this.api.getUserToken();
        if (token) {
            this.verifyToken(token); // show loading screen until this is decidedly approved.
        }
        else {
            this.checkAuthentication();
        }
    };
    BrainBuilder.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.isLoggedInSubscription = this.auth.isAuthenticatedSubscription.subscribe(function (isLoggedIn) {
            _this.isLoggedIn = isLoggedIn;
        });
        this.appNavProvider.setNavController(this.nav);
    };
    /**
     * Don't touch this unless you absolutely need to
     * This method is responsible for checking the
     * initial authentication since this file is always loaded on page
     * load, regardless of login-status
     * If the user is not logged in, the AuthProvider will send them to the login page
     * If the user is logged in, we first check to see if they are trying to
     * navigate to a specific page (i.e. the Projects page)
     * If they are not, we just direct them to the Dashboard by default
     */
    BrainBuilder.prototype.checkAuthentication = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isLoggedIn, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        return [4 /*yield*/, this.auth.checkAuthentication()];
                    case 1:
                        isLoggedIn = _a.sent();
                        if (!isLoggedIn) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.userProvider.load()];
                    case 2:
                        _a.sent();
                        this.showLoadingScreen = false;
                        if (!this.nav.getActive() && !window.location.href.includes('#/')) {
                            this.rootPage = 'DashboardPage';
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        this.showLoadingScreen = false;
                        this.rootPage = 'LoginPage';
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        err_1 = _a.sent();
                        throw err_1;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    BrainBuilder.prototype.invalidToken = function (message) {
        if (message === void 0) { message = 'Sorry, that token is invalid'; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalProvider.presentError(this.translate.instant('Invalid Token'), message, undefined, this.translate.instant('Okay'))];
                    case 1:
                        _a.sent();
                        /**
                         * Remove token from url
                         * So we don't attempt to revalidate it
                         * again if user reloads
                         */
                        window.history.replaceState(null, 'Brain Builder', '/');
                        this.rootPage = 'LoginPage';
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Routes users to proper location
     * based upon token type
     */
    BrainBuilder.prototype.validToken = function (tokenObject) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = tokenObject.message.type;
                        switch (_a) {
                            case 'invitation': return [3 /*break*/, 1];
                            case 'resetPassword': return [3 /*break*/, 7];
                        }
                        return [3 /*break*/, 8];
                    case 1:
                        if (!(tokenObject.message.hasAccount &&
                            tokenObject.message.organizationName &&
                            !tokenObject.message.hasOrganizationAccount)) return [3 /*break*/, 2];
                        this.nav.push('JoinOrganizationPage', {
                            organizationName: tokenObject.message.organizationName,
                            migrate: tokenObject.message.migrate,
                            email: tokenObject.message.email
                        });
                        return [3 /*break*/, 6];
                    case 2:
                        if (!(tokenObject.message.hasOrganziationAccount || tokenObject.message.hasAccount)) return [3 /*break*/, 3];
                        window.history.replaceState(null, 'Brain Builder', '/');
                        this.rootPage = 'LoginPage';
                        return [3 /*break*/, 6];
                    case 3: return [4 /*yield*/, this.localStorageProvider.set('email', tokenObject.message.email)];
                    case 4:
                        _b.sent();
                        return [4 /*yield*/, this.localStorageProvider.set('organizationName', tokenObject.message.organizationName)];
                    case 5:
                        _b.sent();
                        this.rootPage = 'RegisterPage';
                        _b.label = 6;
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        this.rootPage = 'ResetPasswordPage';
                        return [3 /*break*/, 9];
                    case 8: return [3 /*break*/, 9];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    BrainBuilder.prototype.verifyToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var loading, tokenObject, err_2, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        loading = this.loadingCtrl.create({
                            content: this.translate.instant('Verifying Token') + "..."
                        });
                        loading.present();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api.validateUserToken(token)];
                    case 2:
                        tokenObject = _a.sent();
                        loading.dismiss();
                        this.validToken(tokenObject);
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        loading.dismiss();
                        message = void 0;
                        switch (err_2.error.code) {
                            case 'TOKEN_NOT_FOUND':
                                message = this.translate.instant('The token you provided does not exist.');
                                break;
                            case 'TOKEN_EXPIRED':
                                message = this.translate.instant('The token you provided has expired.');
                                break;
                            case 'TOKEN_ALREADY_REDEEMED':
                                message = this.translate.instant('The token you provided has already been redeemed.');
                                break;
                            case 'USER_ALREADY_IN_ORGANIZATION':
                                message = err_2.error.message;
                                break;
                            default:
                                message = this.translate.instant('An unknown error occurred. Please try again later.');
                                // in the unknown case, we want to log this error to bugsnag
                                throw err_2;
                        }
                        this.invalidToken(message);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        ViewChild('myNav'),
        __metadata("design:type", NavController)
    ], BrainBuilder.prototype, "nav", void 0);
    BrainBuilder = __decorate([
        Component({
            templateUrl: 'app.html',
            selector: 'app-base'
        }),
        __metadata("design:paramtypes", [AuthProvider,
            UserProvider,
            TranslationProvider,
            NgZone,
            AppNavProvider,
            OnPremiseProvider,
            API,
            Platform,
            StatusBar,
            SplashScreen,
            LoadingController,
            PopoverProvider,
            ModalProvider,
            LocalStorageProvider,
            InspectorBusyProvider,
            TrackableJobProvider,
            TranslateService,
            SettingsProvider])
    ], BrainBuilder);
    return BrainBuilder;
}());
export { BrainBuilder };
//# sourceMappingURL=app.component.js.map


// WEBPACK FOOTER //
// ./src/app/app.component.ts.pre-build-optimizer.js